import React, { FC } from 'react';
import { TextButton } from '@wix/design-system';
import { dataHooks } from '../../utils/constants';
import useMarketplaceHeaderBi, {
  IMPHeaderPageName,
} from '@components/Hooks/useMarketplaceHeaderBi';

interface StudioTemplatesLinkProps {
  label: string;
  joinMpLink: string;
  pageName: string;
  isMobileView?: boolean;
}

const ApplyToMarketplaceLink: FC<StudioTemplatesLinkProps> = ({
  label,
  joinMpLink,
  pageName,
  isMobileView,
}) => {
  const { reportClick } = useMarketplaceHeaderBi({
    pageName: pageName as IMPHeaderPageName,
  });

  return (
    <TextButton
      as="a"
      dataHook={dataHooks.applyToMarketplaceLink}
      skin="dark"
      size="medium"
      weight={isMobileView ? 'normal' : 'thin'}
      onClick={() => {
        // TODO: update BI
        // reportClick({ clickType: BI_CLICK_TYPES.applyToMarketplace });
      }}
      href={joinMpLink}
    >
      {label}
    </TextButton>
  );
};

export default ApplyToMarketplaceLink;
